import RequestForm from "../../../subComponent/RequestForm";
import Footer from "../../../subComponent/Footer";
import businessicon from '../../../Assets/Img/businessicon.webp'
import databaseicon from '../../../Assets/Img/databaseicon.webp'
import performanceicon from '../../../Assets/Img/performanceicon.webp'

const DataPage = () => {
    return (
        <>
            <div className="bg-white">
                <div className="row">
                    <div className=" col-12  background-setting bespoke-banner p-0">
                        <div className="bespoke-section">
                            <div className="inventory-backdrop p-0 " >
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 px-2 ">Make Quick And Confident Decisions Using Market Leading Analytics That's Backed By Timely Data.</p>
                            </div>
                        </div>
                    </div>
                    <div className=" col-12 col-md-11 background-setting bussiness-background mt-5 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div class="line-before text-white fs_19">Data Analytics </div>
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white fs_32 poppins m-0 pb-4 ">Business Intelligence & Analytics</p>
                                    <p className="sales-text text-white fs_19 poppins m-0 pb-4 ">Growing your business with clear analytics and data means you are not second guessing your decisions.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-1">
                    </div>


                    <div className="  col-12 col-md-4  background-setting intellegence-background p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="bespoke-section">
                                <div className="text-center">
                                    <img src={businessicon} width="60px" alt="Your Image" />
                                </div>
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 ">Business
                                    Intelligence</p>
                                <p className=" bespoke-text text-center text-white fs_14 poppins py-3 ">Gain insights into your business by market leading analytical tools. We utilize the capabilities of software like Power BI, Klipfolio and more to make meaning out of data.</p>
                            </div>
                        </div>
                    </div>
                    <div className="  col-12 col-md-4  background-setting database-background p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="bespoke-section">
                            <div className="text-center">
                                    <img src={databaseicon} width="60px" alt="Your Image" />
                                </div>
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 ">Database Management</p>
                                <p className=" bespoke-text text-center text-white fs_14 poppins py-3 ">Truly understanding data is only the second step. With our highly flexible database management system, we are able to provide the right database for the right situation.</p>
                            </div>
                        </div>
                    </div>
                    <div className=" col-12 col-md-4 background-setting performance-background p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="bespoke-section">
                            <div className="text-center">
                                    <img src={performanceicon} width="60px" alt="Your Image" />
                                </div>
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 ">Performance Management</p>
                                <p className=" bespoke-text text-center text-white fs_14 poppins py-3 ">Not only to we monitor the performance of your business, we are also able to monitor the performance of both your manpower and machineries.</p>
                            </div>
                        </div>
                    </div>

                    <div className="py-5">

                        <RequestForm />
                    </div>

                </div>
                <div className="background-setting deafult-footer py-5">
                    <Footer />
                </div>
            </div>

        </>
    );
}

export default DataPage;